// extracted by mini-css-extract-plugin
export default {"overlay":"TB-z","bodyOpen":"UB-z","content":"VB-z","header":"WB-z","close":"XB-z","closeNoHeading":"YB-z"};